module.exports = __webpack_public_path__ + "img/11.da9a7d14.png";